<!-- 医药：解决方案 -->

<template>
  <div class="medicalSolutions"   :class="{
        solution_img_en: $i18n.locale === 'en_US',solution_img_ja:$i18n.locale === 'ja_JP'
      }">
    <div
      class="solution_img"
    
    >
      <div class="solution-big">
        <!-- <img src="@/assets/images/IndustrySolution/medicalSolutions/solution-big.png" alt=""> -->
        <div class="solution-bg-image">
          <!-- 左边 -->
          <div class="text1 text_color div_position left_color_1">
            {{ $t("solution.medicine.solutions.tab.word0") }}
          </div>
          <div
            class="text1 div_title div_position"
            style="position: absolute; top: 0.6%; left: 9.7%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word1") }}
          </div>
          <div class="div_position left_01">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word2") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word3") }}
            </div>
          </div>
          <div
            class="text1 div_title div_position"
            style="position: absolute; top: 12%; left: 9.7%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word28") }}
          </div>
          <div class="div_position left_02_1">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word29") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word30") }}
            </div>
          </div>
          <div class="div_position left_02_2">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word31") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word32") }}
            </div>
          </div>
          <div class="text1 text_color div_position left_color_2">
            {{ $t("solution.medicine.solutions.tab.word36") }}
          </div>
          <div class="text1 text_color div_position left_color_3">
            {{ $t("solution.medicine.solutions.tab.word37") }}
          </div>
          <div class="text1 text_color div_position left_color_4">
            {{ $t("solution.medicine.solutions.tab.word34") }}
          </div>
          <div
            class="text1 div_title div_position"
            style="position: absolute; top: 29%; left: 9.7%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word38") }}
          </div>
          <div class="div_position left_03_1">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word33") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word35") }}
            </div>
          </div>
          <div class="div_position left_03_2">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word39") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word40") }}
            </div>
          </div>
          <div class="text2" style="top: 48%; left: 1.5%">
            {{ $t("solution.medicine.solutions.tab.word42") }}
          </div>
          <div class="text2" style="top: 48%; left: 94.5%">
            {{ $t("solution.medicine.solutions.tab.word43") }}
          </div>
          <div
            class="text1 div_title div_position"
            style="position: absolute; top: 46%; left: 9.7%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word41") }}
          </div>
          <div class="div_position left_04_1">
            <div class="text1 div_width2 display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word44") }}
            </div>
            <div class="text1 div_width2 display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word45") }}
            </div>
            <div class="text1 div_width2 display_center">
              {{ $t("solution.medicine.solutions.tab.word46") }}
            </div>
          </div>
          <div class="div_position left_04_2">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word47") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word48") }}
            </div>
          </div>
          <div
            class="text1 div_title div_position"
            style="
              position: absolute;
              bottom: 33.5%;
              left: 9.7%;
              fontweight: bold;
            "
          >
            {{ $t("solution.medicine.solutions.tab.word61") }}
          </div>
          <div class="div_position left_05">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word62") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word63") }}
            </div>
          </div>
          <div
            class="text1 div_title div_position"
            style="
              position: absolute;
              bottom: 22%;
              left: 9.7%;
              fontweight: bold;
            "
          >
            {{ $t("solution.medicine.solutions.tab.word64") }}
          </div>
          <div class="div_position left_06">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word65") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word66") }}
            </div>
          </div>
          <div
            class="text1 div_title div_position"
            style="
              position: absolute;
              bottom: 10.5%;
              left: 10%;
              fontweight: bold;
            "
          >
            {{ $t("solution.medicine.solutions.tab.word67") }}
          </div>
          <div class="div_position left_07_1">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word68") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word69") }}
            </div>
          </div>
          <div class="div_position left_07_2">
            <div class="text1 div_width display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word70") }}
            </div>
            <div class="text1 div_width display_center">
              {{ $t("solution.medicine.solutions.tab.word71") }}
            </div>
          </div>
          <!-- 右边 -->
          <div
            class="text1 div_title_font"
            style="position: absolute; top: 1.5%; left: 44.5%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word4") }}
          </div>
          <div class="text1 div_position right_color_1">
            {{ $t("solution.medicine.solutions.tab.word5") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 5%; left: 44.5%"
          >
            {{ $t("solution.medicine.solutions.tab.word6") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 5%; left: 60.5%"
          >
            {{ $t("solution.medicine.solutions.tab.word7") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 5%; left: 76.5%"
          >
            {{ $t("solution.medicine.solutions.tab.word8") }}
          </div>

          <div
            class="text1 div_width3"
            style="position: absolute; top: 13%; left: 44.5%"
          >
            {{ $t("solution.medicine.solutions.tab.word9") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 13%; left: 60.5%"
          >
            {{ $t("solution.medicine.solutions.tab.word10") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 13%; left: 76.5%"
          >
            {{ $t("solution.medicine.solutions.tab.word11") }}
          </div>

          <div
            class="text1 div_title_font"
            style="position: absolute; top: 23%; left: 44.5%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word12") }}
          </div>
          <div
            class="text1 div_title_font"
            style="position: absolute; top: 23%; left: 77%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word13") }}
          </div>
          <div class="div_position right_02">
            <div class="text1 div_width4_1 display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word14") }}
            </div>
            <div class="text1 div_width4_2 display_center">
              {{ $t("solution.medicine.solutions.tab.word15") }}
            </div>
          </div>
          <div class="div_position right_06 display_dir_col">
            <div class="text1 div_width6 display_center">
              {{ $t("solution.medicine.solutions.tab.word16") }}
            </div>
            <div class="text1 div_width4 display_center right_06_2">
              {{ $t("solution.medicine.solutions.tab.word18") }}
            </div>
            <div class="text1 div_width6 display_center">
              {{ $t("solution.medicine.solutions.tab.word21") }}
            </div>
            <div class="text1 div_width6 display_center">
              {{ $t("solution.medicine.solutions.tab.word23") }}
            </div>
          </div>
          <div class="div_position right_07 display_dir_col">
            <div class="text1 div_width4 display_center">
              {{ $t("solution.medicine.solutions.tab.word58") }}
            </div>
            <div class="text1 div_width6 display_center">
              {{ $t("solution.medicine.solutions.tab.word59") }}
            </div>
            <div class="text1 div_width6 display_center">
              {{ $t("solution.medicine.solutions.tab.word60") }}
            </div>
          </div>

          <div class="text1 div_position right_color_2">
            {{ $t("solution.medicine.solutions.tab.word17") }}
          </div>
          <div class="text1 div_position right_color_5">
            {{ $t("solution.medicine.solutions.tab.word19") }}
          </div>
          <div class="text1 div_position right_color_3">
            {{ $t("solution.medicine.solutions.tab.word20") }}
          </div>
          <div class="text1 div_position right_color_4">
            {{ $t("solution.medicine.solutions.tab.word22") }}
          </div>

          <div
            class="text1 div_title_font"
            style="position: absolute; top: 36%; left: 44.5%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word24") }}
          </div>
          <div class="div_position right_03_1">
            <div class="text1 div_width5 display_center">
              {{ $t("solution.medicine.solutions.tab.word25") }}
            </div>
          </div>
          <div class="div_position right_03_2">
            <div class="text1 div_width6 display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word26") }}
            </div>
            <div class="text1 div_width6 display_center">
              {{ $t("solution.medicine.solutions.tab.word27") }}
            </div>
          </div>

          <div
            class="text1 div_title_font"
            style="position: absolute; top: 53%; left: 44.5%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word49") }}
          </div>
          <div class="div_position right_04">
            <div class="text1 div_width4 display_center div_right">
              {{ $t("solution.medicine.solutions.tab.word50") }}
            </div>
            <div class="text1 div_width4 display_center right_06_2">
              {{ $t("solution.medicine.solutions.tab.word51") }}
            </div>
          </div>
          <div
            class="text1 div_title_font"
            style="position: absolute; top: 67%; left: 44.55%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word52") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 71%; left: 44.5%; width: 176px"
          >
            {{ $t("solution.medicine.solutions.tab.word53") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 71%; left: 59.5%; width: 176px"
          >
            {{ $t("solution.medicine.solutions.tab.word54") }}
          </div>
          <div class="text1 text1_1_ja" style="position: absolute; top: 79%; left: 48.5%">
            {{ $t("solution.medicine.solutions.tab.word55") }}
          </div>
          <div class="text1" style="position: absolute; top: 79%; left: 63.5%">
            {{ $t("solution.medicine.solutions.tab.word56") }}
          </div>
          <div
            class="text1 div_title_font"
            style="position: absolute; top: 61%; left: 77%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word57") }}
          </div>
          <div
            class="text1 div_title_font"
            style="position: absolute; top: 87%; left: 44.5%; fontweight: bold"
          >
            {{ $t("solution.medicine.solutions.tab.word72") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 92%; left: 44.5%; width: 140px"
          >
            {{ $t("solution.medicine.solutions.tab.word73") }}
          </div>
          <div class="text1" style="position: absolute; top: 91.3%; left: 59%">
            {{ $t("solution.medicine.solutions.tab.word74") }}
          </div>
          <div class="text1" style="position: absolute; top: 95.8%; left: 59%">
            {{ $t("solution.medicine.solutions.tab.word75") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 92%; left: 68%; width: 140px"
          >
            {{ $t("solution.medicine.solutions.tab.word76") }}
          </div>
          <div
            class="text1 div_width3"
            style="position: absolute; top: 92%; left: 80.5%; width: 140px"
          >
            {{ $t("solution.medicine.solutions.tab.word77") }}
          </div>
        </div>
      </div>
    </div>

    <!-- 内容 -->
    <div class="pro-content mt--40">
      <div class="box" :style="{ transform: `translateX(${position}px)` }">
        <div
          class="item"
          v-for="(list, index) in itemList"
          :key="index"
          >
          <div class="item-img">
            <div class="item-img_card display_center">
              <img :src="list.img01" alt="" />
            </div>
          </div>
          <div class="item-title">{{ list.title }}</div>
          <div
       
            class="hidden-content"
          >
            <div class="wrapper">
              <div class="hidden-title">{{ list.title }}</div>
              <div class="hidden-text">{{ list.content }}</div>
            </div>
          </div>
        </div>
      </div>
      <div @click="moveBoxLeft" class="btnLeft">
        <img :src="rightIcon" alt="" />
      </div>
      <div @click="moveBoxRight" class="btnRight" v-show="showleftIcon">
        <img :src="leftIcon" alt="" />
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      position: 0,
      containerWidth: 0,
      boxWidth: 0,
      showleftIcon: false,
      showContent: false,
      currentIndex: null,
      leftIcon: require('@/assets/images/IndustrySolution/medicalSolutions/left-icon.png'),
      rightIcon: require('@/assets/images/IndustrySolution/medicalSolutions/right-icon.png'),
      itemList: [
        {
          id: 1,
          title: this.$t('solution.medicine.solutions.card.title1'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon01.png'),
          content: this.$t('solution.medicine.solutions.card.desc1')
        },
        {
          id: 2,
          title: this.$t('solution.medicine.solutions.card.title2'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon02.png'),
          content: this.$t('solution.medicine.solutions.card.desc2')
        },
        {
          id: 3,
          title: this.$t('solution.medicine.solutions.card.title3'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon03.png'),
          content: this.$t('solution.medicine.solutions.card.desc3')
        },
        {
          id: 4,
          title: this.$t('solution.medicine.solutions.card.title4'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon04.png'),
          content: this.$t('solution.medicine.solutions.card.desc4')
        },
        {
          id: 5,
          title: this.$t('solution.medicine.solutions.card.title5'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon05.png'),
          content: this.$t('solution.medicine.solutions.card.desc5')
        },
        {
          id: 6,
          title: this.$t('solution.medicine.solutions.card.title6'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon06.png'),
          content: this.$t('solution.medicine.solutions.card.desc6')
        },
        {
          id: 7,
          title: this.$t('solution.medicine.solutions.card.title7'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon07.png'),
          content: this.$t('solution.medicine.solutions.card.desc7')
        },
        {
          id: 8,
          title: this.$t('solution.medicine.solutions.card.title8'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon08.png'),
          content: this.$t('solution.medicine.solutions.card.desc8')
        },
        {
          id: 9,
          title: this.$t('solution.medicine.solutions.card.title9'),
          img01: require('@/assets/images/IndustrySolution/medicalSolutions/solution-icon09.png'),
          content: this.$t('solution.medicine.solutions.card.desc9')
        }
      ]
    };
  },

  methods: {
    moveBoxLeft () {
      //console.log('this.position',this.position)
      if (this.position != -1400) {
        this.position -= 350;
        this.showleftIcon = true;
      }
      if (this.position == 0) {
        this.showleftIcon = false;
      }
    },
    moveBoxRight () {
      if (this.position != 0) {
        this.position += 350;
        this.showleftIcon = true;
      }
      if (this.position == 0) {
        this.showleftIcon = false;
      }
    }
  }
};
</script>

